import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IQueryParam, IFilter, ILogHttp } from 'modelos/src';
import { Subscription } from 'rxjs';
import { IColumnas } from '../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';

import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { LoginService } from '../../../login/login.service';
import { MatDialog } from '@angular/material/dialog';
import { LogHttpService } from '../../../../auxiliares/servicios/http/log-http.service';
import { fechaLogHtml } from '../fecha-log';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { escaparHtml } from '../../../../auxiliares/html-seguro.util';

@Component({
  selector: 'app-listado-request-http',
  templateUrl: './listado-request-http.component.html',
  styleUrl: './listado-request-http.component.scss',
  standalone: false,
})
export class ListadoRequestHttpComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  matDialog = inject(MatDialog);
  logHttpService = inject(LogHttpService);

  public loading = false;
  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoRequestHttpComponent';
  public logHttp?: ILogHttp[];
  public totalCount = 0;
  public columnas?: IColumnas<ILogHttp>[];
  public logHttpSeleccionado?: ILogHttp;
  // Subs
  public logHttp$?: Subscription;

  // FILTROS
  // Buscar
  public search: IRegExpSearch = {
    fields: ['identificacion'],
  };
  // Fecha de creación
  private fechaCreacion: IFiltroTabla = {
    filter: {
      field: 'fechaCreacion',
    },
    label: 'Buscar por fecha',
    tipo: 'dateRange',
  };
  //
  public filtros: IFiltroTabla[] = [this.fechaCreacion];
  // Query
  public filter: IFilter<ILogHttp> = {};
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
    select: '-__v',
  };

  // Listars
  public async listar(): Promise<void> {
    this.logHttp$?.unsubscribe();
    this.logHttp$ = this.lista2.logHttps(this.query, 30).subscribe((data) => {
      this.totalCount = data.totalCount;
      this.logHttp = data.datos;
    });
  }

  // Acciones

  public verDetalles(dato: ILogHttp): void {
    this.logHttpSeleccionado = dato;
  }

  public cerrarDetalles(): void {
    this.logHttpSeleccionado = undefined;
  }
  /////////////////////////////////////////////////////////////
  // Tabla

  private setColumnas() {
    const columnas: IColumnas<ILogHttp>[] = [
      // Fecha de request (con segundos: en los logs importan)
      {
        header: {
          label: 'Fecha',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          html: (dato) => fechaLogHtml(dato.fechaCreacion),
          noData: 'Sin fecha',
        },
      },

      // Método
      {
        header: {
          label: 'Método',
        },
        row: {
          html: (dato) => {
            const metodo = dato?.method?.toUpperCase();
            return metodo
              ? `<span class="tabla-codigo">${escaparHtml(metodo)}</span>`
              : '';
          },
          noData: 'Sin método',
        },
      },

      // URL
      {
        header: {
          label: 'URL',
        },
        row: {
          field: 'url',
          noData: 'Sin URL',
        },
      },
    ];

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.logHttp$?.unsubscribe();
  }
}
